import React from 'react';

import { formatDate, formatDateWithHour } from 'src/utils/Date';
import styles from './TargetDateWithReleaseDate.scss';
import { useTranslation } from 'react-i18next';

const TargetDateWithReleaseDate = ({
  startDate,
  endDate,
  paymentDate,
  attendanceStartDate,
  attendanceEndDate,
  confirmed = null,
  releaseDate = null
}) => {
  const { t } = useTranslation();
  const showReleaseDate = confirmed ? (
    <span className={styles.release}>{t('components.PayTargetDateRange.Disclosure_date')}：{formatDateWithHour(releaseDate)}</span>
  ) : (
    ''
  );

  const attendanceTime =
    attendanceStartDate && startDate !== attendanceStartDate ? (
      <span className="u-ml20">
        （{t('components.PayTargetDateRange.Applicable_attendance_period')}: {formatDate(attendanceStartDate)} ~ {formatDate(attendanceEndDate)}）
      </span>
    ) : (
      ''
    );

  return (
    <React.Fragment>
      <span>
        {t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.subjected_period')}：{formatDate(startDate)} ~ {formatDate(endDate)}
      </span>
      {attendanceTime}
      <span className="u-ml20">{t('features.EmployeePays.components.DownloadColumnDetail.payment_date')}：{formatDate(paymentDate)}</span>
      {showReleaseDate}
    </React.Fragment>
  );
};

export default TargetDateWithReleaseDate;
